const historyOpts = {
    selector: '.result--list h2 a',
};

export default historyOpts;
